export function getReactHOTComposeFunction(_a) {
    var internalPart = (_a === void 0 ? {} : _a).internalPart;
    return {
        isDev: true,
        transform: function (_a) {
            var value = _a.value;
            return {
                imports: [['@wix/component-hot-loader', 'hot']],
                value: internalPart
                    ? "{..." + value + ", ['" + internalPart + "']: hot(module, " + value + "['" + internalPart + "'])}"
                    : "hot(module, " + value + ")",
            };
        },
    };
}
//# sourceMappingURL=presets.js.map